<template>
  <v-container grid-list-md text-xs-center fluid>
    <v-row wrap>
      <v-text-field
        append-icon="search"
        v-model="searchText"
        :placeholder="resx.labels.searchEmployees"
      >
      </v-text-field>
    </v-row>
    <v-row wrap>
      <v-col>
        <v-list
          two-line
          v-if="filteredEmployees && filteredEmployees.length > 0"
        >
          <template v-for="(employee, index) in filteredEmployees">
            <v-list-group
              :sub-group="$vuetify.breakpoint.smAndUp"
              :no-action="$vuetify.breakpoint.smAndUp"
              :key="employee._id"
              :value="false"
              v-if="
                $store.state.auth.user.roles[0] !=
                  $store.state.constants.roles.SECURITY
              "
            >
              <v-list-item slot="activator">
                <v-list-item-action>
                  <v-tab>
                    <v-icon color="primary">people</v-icon>
                    <v-badge overlap color="error" v-if="countInvalidObligations(employee) > 0">
                      <span slot="badge">{{
                        countInvalidObligations(employee) }}
                      </span>
                    </v-badge>
                  </v-tab>
                </v-list-item-action>
                <v-list-item-content style="max-width: 220px;">
                  <v-list-item-title>
                    <text-highlight :queries="searchText">{{
                      employee.firstName
                    }}</text-highlight
                    >&nbsp;<text-highlight :queries="searchText">{{
                      employee.lastName
                    }}</text-highlight>
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    {{ `${employee.identifier.type.toUpperCase()} `
                    }}<text-highlight :queries="searchText">{{
                      employee.identifier.number
                    }}</text-highlight>
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action v-if="$vuetify.breakpoint.smAndUp">
                  <v-btn
                    icon
                    text
                    color="primary"
                    :disabled="!employee.comments"
                    @click.stop="
                    $emit('viewComment', {
                        title: employee.description,
                        value: employee.comments
                      })
                    "
                  >
                    <v-icon>comment</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
              <v-divider></v-divider>
              <contractor-obligations-details
                :obligations="getEmployeeObligations(employee)"
                @viewComment="$emit('viewComment', $event)"
              ></contractor-obligations-details>
            </v-list-group>
            <v-list-item :key="employee._id" v-else>
              <v-list-item-action>
                <v-icon :color="isDelayed(employee._id) ? 'error' : 'green'"
                  >people</v-icon
                >
              </v-list-item-action>
              <v-list-item-content style="max-width: 220px;">
                <v-list-item-title>
                  {{ `${resx.labels.name}: `
                  }}<text-highlight :queries="searchText">{{
                    employee.firstName
                  }}</text-highlight
                  >&nbsp;<text-highlight :queries="searchText">{{
                    employee.lastName
                  }}</text-highlight>
                </v-list-item-title>
                <v-list-item-subtitle>
                  {{ `${employee.identifier.type.toUpperCase()} `
                  }}<text-highlight :queries="searchText">{{
                    employee.identifier.number
                  }}</text-highlight>
                </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action v-if="visit">
                <v-checkbox
                  v-if="isIncluded(employee._id) || isAlreadyIn(employee._id)"
                  color="indigo"
                  hide-details
                  light
                  input-value="true"
                  disabled
                ></v-checkbox>
                <v-checkbox
                  v-else
                  color="indigo"
                  hide-details
                  light
                  disabled
                ></v-checkbox>
              </v-list-item-action>
              <v-list-item-action v-else>
                <v-checkbox
                  v-if="isAlreadyIn(employee._id)"
                  color="indigo"
                  hide-details
                  light
                  input-value="true"
                  disabled
                ></v-checkbox>
                <v-checkbox
                  v-if="!isAlreadyIn(employee._id)"
                  color="indigo"
                  hide-details
                  light
                  v-model="checkedEmployees[index]"
                  :value="employee"
                  @change="updateEmployees(employee)"
                ></v-checkbox>
              </v-list-item-action>
              <v-list-item-action>
                <v-btn
                  icon
                  text
                  color="primary"
                  @click.stop="
                    $emit('viewComment', {
                      title: employee.fullName,
                      value: employee.comments
                    })
                  "
                  :disabled="!employee.comments"
                >
                  <v-icon>comment</v-icon>
                </v-btn>
              </v-list-item-action>
              <v-list-item-action>
                <v-col>
                  <v-row
                    v-if="
                      $store.state.auth.user.roles[0] ==
                        $store.state.constants.roles.SECURITY &&
                        personalProtectionItems.verify
                    "
                  >
                    <div
                      v-bind:key="employee._id"
                      v-if="!isAlreadyIn(employee._id)"
                    >
                      <v-row class="personal-protection-items-validate-row">
                        <v-checkbox
                          color="green"
                          hide-details
                          light
                          v-model="
                            employee.currentPersonalProtectionItems.helmet
                          "
                          :disabled="!personalProtectionItems.helmet || isAccessApproved"
                          @change="updatePersonalProtectionItem(employee)"
                        ></v-checkbox>
                        <v-checkbox
                          color="green"
                          hide-details
                          light
                          v-model="
                            employee.currentPersonalProtectionItems
                              .securityShoes
                          "
                          :disabled="!personalProtectionItems.securityShoes || isAccessApproved"
                          @change="updatePersonalProtectionItem(employee)"
                        ></v-checkbox>
                        <v-checkbox
                          color="green"
                          hide-details
                          light
                          v-model="
                            employee.currentPersonalProtectionItems.gloves
                          "
                          :disabled="!personalProtectionItems.gloves || isAccessApproved"
                          @change="updatePersonalProtectionItem(employee)"
                        ></v-checkbox>
                        <v-checkbox
                          color="green"
                          hide-details
                          light
                          v-model="
                            employee.currentPersonalProtectionItems.goggles
                          "
                          :disabled="!personalProtectionItems.goggles || isAccessApproved"
                          @change="updatePersonalProtectionItem(employee)"
                        ></v-checkbox>
                        <v-checkbox
                          color="green"
                          hide-details
                          light
                          v-model="
                            employee.currentPersonalProtectionItems
                              .auditoryProtector
                          "
                          :disabled="!personalProtectionItems.auditoryProtector || isAccessApproved"
                          @change="updatePersonalProtectionItem(employee)"
                        ></v-checkbox>
                      </v-row>
                      <v-row
                        ma-0
                        pa-0
                        class="personal-protection-items-validate-row"
                      >
                        <v-checkbox
                          color="green"
                          hide-details
                          light
                          v-model="
                            employee.currentPersonalProtectionItems.gasMask
                          "
                          :disabled="!personalProtectionItems.gasMask || isAccessApproved"
                          @change="updatePersonalProtectionItem(employee)"
                        ></v-checkbox>
                        <v-checkbox
                          color="green"
                          hide-details
                          light
                          v-model="
                            employee.currentPersonalProtectionItems.uniform
                          "
                          :disabled="!personalProtectionItems.uniform || isAccessApproved"
                          @change="updatePersonalProtectionItem(employee)"
                        ></v-checkbox>
                        <v-checkbox
                          color="green"
                          hide-details
                          light
                          v-model="
                            employee.currentPersonalProtectionItems
                              .reflectiveVest
                          "
                          :disabled="!personalProtectionItems.reflectiveVest || isAccessApproved"
                          @change="updatePersonalProtectionItem(employee)"
                        ></v-checkbox>
                        <v-checkbox
                          color="green"
                          hide-details
                          light
                          v-model="
                            employee.currentPersonalProtectionItems
                              .safetyHarness
                          "
                          :disabled="!personalProtectionItems.safetyHarness || isAccessApproved"
                          @change="updatePersonalProtectionItem(employee)"
                        ></v-checkbox>
                        <v-checkbox
                          color="green"
                          hide-details
                          light
                          v-model="
                            employee.currentPersonalProtectionItems.weldingMask
                          "
                          :disabled="!personalProtectionItems.weldingMask || isAccessApproved"
                          @change="updatePersonalProtectionItem(employee)"
                        ></v-checkbox>
                      </v-row>
                    </div>
                  </v-row>
                </v-col>
              </v-list-item-action>
            </v-list-item>
          </template>
        </v-list>
      </v-col>
    </v-row>
    <!--
      <v-alert color="primary" icon="info" v-else :value="true">
        {{ resx.messages.noDataAvailable }}
      </v-alert>
    -->
  </v-container>
</template>

<script>
"use strict";

import contractorObligationsDetails from "./contractor-obligations-details.view.vue";
import TextHighlight from "vue-text-highlight";

export default {
  name: "contractorObligationsEmployeesDetails",
  components: {
    contractorObligationsDetails,
    TextHighlight
  },
  computed: {
    isAccessApproved() {
      return this.visit && ['authorized', 'active'].includes(this.visit.state);
    },
    filteredEmployees() {
      const regexp = new RegExp(this.searchText, "i");
      return this.employees.filter(e => {
        return (
          (!this.visit || (this.visit && this.isIncluded(e._id))) &&
          (regexp.test(e.firstName) ||
            regexp.test(e.lastName) ||
            regexp.test(e.identifier.number))
        );
      });
    }
  },
  data() {
    return {
      searchText: "",
      checkedEmployees: []
    };
  },
  methods: {
    isIncluded(id) {
      return this.visit.employees.includes(String(id));
    },
    isAlreadyIn(id) {
      return this.alreadyIn.includes(String(id));
    },
    isAuthorized() {
      let isAuthorized = true;
      for (let index in this.checkedEmployees) {
        if (this.checkedEmployees[index] != null) {
          isAuthorized =
            isAuthorized && !this.isDelayed(this.checkedEmployees[index]._id);
        }
      }
      return isAuthorized;
    },
    countInvalidObligations(employee) {
      const delayedObligations = this.getEmployeeObligations(employee).filter(
        o => o.status == this.$store.state.constants.OBLIGATIONS.STATUS.DELAYED
      );
      return delayedObligations.length;
    },
    getEmployeeObligations(employee) {
      return this.obligations.filter(o => o.referenceId == employee._id);
    },
    isDelayed(id) {
      return this.delayedObligations && this.delayedObligations.length > 0
        ? this.delayedObligations.filter(o => o.referenceId == id).length > 0
        : false;
    },
    updateEmployees(employee) {
      employee.currentPersonalProtectionItems.selected = !employee
        .currentPersonalProtectionItems.selected;
      this.$emit("updateEmployees", employee, this.isAuthorized());
    },
    updatePersonalProtectionItem(employee) {
      this.$emit("updatePersonalProtectionItem", employee, this.isAuthorized());
    }
  },
  props: {
    alreadyIn: { type: Array },
    delayedObligations: { type: Array },
    employees: { type: Array },
    obligations: { type: Array },
    personalProtectionItems: { type: Object },
    visit: { type: Object }
  }
};
</script>
